import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { Button, Box, Typography } from "@mui/material";
import { getAllMembersByCompanyID } from "../../../../../api/myCompany";
import FormModal from "../../../../../components/FormModal/FormModal";
import Select from "../../../../../components/Select/Select";

function DialogChangeApplicant({
    claimModalVisible,
    handleClaimModalVisibility,
    searchUser,
    deleteFoundUser,
    companySelected,
    onClick,
    title = "Cambiar Solicitante",
    sendButtonLabel = "CONFIRMAR",
}) {
    const initialData = {
        value: "",
        label: "Selecciona un miembro",
    };
    const [requestMembers, setRequestMembers] = useState([]);
    const [requestMemberId, setRequestMemberId] = useState("");

    const { data: usersMembers } = useQuery(
        ["allMembers", companySelected],
        () => getAllMembersByCompanyID(companySelected),
        { enabled: Boolean(companySelected && claimModalVisible) }
    );

    const handleChangeType = (e) => {
        setRequestMemberId(e.target.value);
    };

    const handleClose = () => {
        setRequestMemberId("");
        handleClaimModalVisibility();
    };

    useEffect(() => {
        if (usersMembers?.payload?.data) {
            const reducedArray = usersMembers.payload.data.reduce((acc, curr) => {
                if (!acc.some((item) => item.value === curr.citizen)) {
                    acc.push({ value: curr.citizen, label: `${curr.name} ${curr.first_last_name}` });
                }
                return acc;
            }, []);
            setRequestMembers(() => [initialData, ...reducedArray]);
        }
    }, [usersMembers]);

    return (
        <FormModal
            open={claimModalVisible}
            onClose={handleClose}
            title={title}
            maxWidth="sm"
            fullWidth={true}
        >
            <Box sx={{ mt: 1, mb: 2 }}>
                <Typography sx={{ fontSize: '13.5px', color: '#64748B', fontFamily: 'Roboto, sans-serif', mb: 2.5, lineHeight: 1.5 }}>
                    Seleccione el miembro de la empresa al que desea reasignar el seguimiento y gestión de esta solicitud:
                </Typography>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', mb: 4 }}>
                    <Typography sx={{ fontSize: '12.5px', fontWeight: 700, color: '#0F2350', fontFamily: 'Roboto, sans-serif' }}>
                        Nuevo Solicitante *
                    </Typography>
                    <Select
                        id="selectMembers"
                        data={requestMembers}
                        value={requestMemberId}
                        onChange={handleChangeType}
                        disableEmptyValue
                        style={{ width: '100%' }}
                    />
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                    <Button
                        variant="outlined"
                        onClick={handleClose}
                        sx={{
                            borderRadius: '10px',
                            borderColor: '#CBD5E1',
                            color: '#64748B',
                            textTransform: 'none',
                            fontWeight: 700,
                            px: 3,
                            py: 1,
                            '&:hover': {
                                borderColor: '#94A3B8',
                                backgroundColor: '#F8FAFC'
                            }
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        disabled={!requestMemberId}
                        onClick={() => {
                            onClick(requestMemberId);
                            setRequestMemberId("");
                        }}
                        sx={{
                            bgcolor: '#0F2350',
                            color: '#FFFFFF',
                            borderRadius: '10px',
                            textTransform: 'none',
                            fontWeight: 700,
                            px: 3,
                            py: 1,
                            boxShadow: 'none',
                            '&:hover': {
                                bgcolor: '#EA361A',
                                boxShadow: 'none'
                            },
                            '&.Mui-disabled': {
                                bgcolor: '#E2E8F0',
                                color: '#94A3B8'
                            }
                        }}
                    >
                        {sendButtonLabel}
                    </Button>
                </Box>
            </Box>
        </FormModal>
    );
}

export default DialogChangeApplicant;
